//Also used id filter, dup
import {getCalendarTooltips, getLang, getLocale} from "./utils/localeUtils";
import {validateTelInputs} from "./utils/validateTelInputs";
import {addParamToUrl, getUrlParameter} from "./utils/urlHelpers";
import {dateFromString, formatDate, getReservationMaxDate} from "./utils/dateHelpers";
import {fetchSignificantDays, buildOnRenderDay} from "./utils/significantDays";
import {initNeedHelpButton, initNeedHelpWhatsappButton} from "./utils/needHelp";

validateTelInputs();
const placeId = getUrlParameter("place");
const placeDataEl = document.getElementById("place-data");
let minDays = 2;
const locale = getLocale();
var significantDaysMap = {};

if (placeDataEl) {
    let minDaysValue = parseInt(placeDataEl.getAttribute("data-min-days"));
    if (minDaysValue > 0) {
        minDays = minDaysValue;
    }
}

let dateInputs = document.querySelectorAll("#reservation_dateString");
if (dateInputs.length) {
    if (typeof (Litepicker) !== "undefined") {
        var litepickers = [];
        let isInitializing = false;

        for (let i = 0; i < dateInputs.length; i++) {
            let input = dateInputs[i];

            var litepicker = new Litepicker({
                element: input,
                singleMode: false,
                numberOfMonths: 2,
                numberOfColumns: 2,
                minDays: minDays,
                hotelMode: true,
                minDate: new Date(),
                maxDate: getReservationMaxDate(),
                allowRepick: true,
                locale: locale,
                format: "D. M. YYYY",
                tooltipNights: true,
                autoRefresh: true,
                footer: "<div class='date-picker-footer'></div>",
                lang: getLang(locale),
                tooltipText: getCalendarTooltips(locale),
                onRenderDay: buildOnRenderDay(significantDaysMap),
                buttonText: {
                    prev: '<i class="fas fa-angle-left"></i>',
                    next: '<i class="fas fa-angle-right"></i>',
                    close: '×',
                    reset: 'Reset',
                    apply: 'Apply'
                },
                onShow: function () {
                    let footer = $(".litepicker");
                    footer.css("margin-top", "0px");

                    if (footer.length > 0) {
                        $.ajax({
                            url: "/editable-string/informace-k-terminum-filtr",
                            method: "GET",
                            success: function (r) {
                                footer.css("width", $(".litepicker").css("width"));

                                footer.append("<div class='litepicker-footer'>" + r + "</div>");
                            }
                        })
                    }
                },
                onSelect: function (date1, date2) {
                    let thisPicker = this;

                    const dateFrom = formatDate(date1, "-");
                    const dateTo = formatDate(date2, "-");

                    input.classList.remove("is-invalid");

                    if (dateFrom && dateTo) {
                        if(input.id === 'reservation_dateString') {
                            addParamToUrl("dateFrom", dateFrom, false);
                            addParamToUrl("dateTo", dateTo, !isInitializing);
                        }

                        const apartment = getUrlParameter("apartment");

                        $.ajax({
                            url: "/api/date/check-availability/" + placeId + "/" + dateFrom + "/" + dateTo + "?apartment=" + apartment,
                            method: "GET",
                            success: function (r) {
                                if (r === "not-available") {
                                    thisPicker.clearSelection();
                                    input.click();

                                    input.classList.add("is-invalid");
                                    alert(input.getAttribute("data-reserved-date-error"))
                                }
                            }
                        });

                        $.ajax({
                            url: "/api/date/price-note/" + placeId + "/" + dateFrom + "/" + dateTo + "?apartment=" + apartment,
                            method: "GET",
                            success: function (r) {
                                const closesInputWrap = $(input).closest(".date-input-wrapper");
                                closesInputWrap.find(".price-note").html(r);
                            }
                        });
                    }
                }
            });

            if (input.id === 'reservation_dateString') {
                const dateFrom = getUrlParameter("dateFrom");
                const dateTo = getUrlParameter("dateTo");

                if (dateFrom && dateTo) {
                    const dateFromObj = dateFromString(dateFrom);
                    const dateToObj = dateFromString(dateTo);

                    if (dateFromObj && dateToObj) {
                        isInitializing = true;
                        litepicker.setDateRange(dateFromObj, dateToObj);
                        isInitializing = false;
                    }
                }
            }

            litepickers.push(litepicker);
        }
    }
}

$(document).ready(function () {
    var disabledDates = [];

    initNeedHelpButton();
    initNeedHelpWhatsappButton();

    function getReservedFutureDates() {
        const placeId = getUrlParameter("place");

        return $.ajax({
            url: "/api/place/" + placeId + "/reserved-future-dates?apartment=" + getUrlParameter("apartment"),
            method: "GET",
            success: function (r) {
                r.forEach(function (item) {
                    const itemValue = item.replace("-single-day", "");

                    disabledDates.push(new Date(itemValue));
                });
            }
        });
    }

    const placeId = getUrlParameter("place");

    let seasonDisabledDates = $.ajax({
        url: "/api/season/disabled-dates?placeId=" + placeId,
        method: "GET",
        success: function (r) {
            r.forEach(function (item) {
                disabledDates.push(new Date(item));
            });
        }
    });

    let reservedDates = getReservedFutureDates();

    $.when(seasonDisabledDates, reservedDates).then(setLockDays, setLockDays);

    fetchSignificantDays().then(function (r) {
        Object.assign(significantDaysMap, r);

        for (let i = 0; i < litepickers.length; i++) {
            litepickers[i].render();
        }
    });

    //filter by apartments
    $(".apartment-dropdown-item").click(function (e) {
        e.preventDefault();

        const apartment = $(this).data("apartment");
        const label = $(this).text();

        $("#apartmentsDropdownLabel").html(label);

        $(".apartment-dropdown-item").removeClass("active");
        $(this).addClass("active");

        addParamToUrl("apartment", apartment, false);

        disabledDates = disabledDates.slice();
        let newReservedFutureDates = getReservedFutureDates();

        $.when(newReservedFutureDates).then(setLockDays);

        for (let i = 0; i < litepickers.length; i++) {
            let litepicker = litepickers[i];
            let input = litepicker.element;

            const dateFrom = formatDate(litepicker.getStartDate(), "-");
            const dateTo = formatDate(litepicker.getEndDate(), "-");

            if (dateFrom && dateTo) {
                $.ajax({
                    url: "/api/date/check-availability/" + placeId + "/" + dateFrom + "/" + dateTo + "?apartment=" + apartment,
                    method: "GET",
                    success: function (r) {
                        if (r === "not-available") {
                            litepicker.clearSelection();
                        }
                    }
                });

                $.ajax({
                    url: "/api/date/price-note/" + placeId + "/" + dateFrom + "/" + dateTo + "?apartment=" + apartment,
                    method: "GET",
                    success: function (r) {
                        const closesInputWrap = $(input).closest(".date-input-wrapper");
                        closesInputWrap.find(".price-note").html(r);
                    }
                });
            }
        }
    });

    function setLockDays() {
        for (let i = 0; i < litepickers.length; i++) {
            let litepicker = litepickers[i];
            litepicker.setLockDays(disabledDates);
            let startDate = litepicker.getStartDate();
            let endDate = litepicker.getEndDate();
            if (startDate && endDate) {
                const daysApart = (endDate - startDate) / (1000 * 60 * 60 * 24);

                const containsStartDate = disabledDates.find(function (date, index) {
                    return date.toDateString() === startDate.toDateString();
                });

                const containsEndDate = disabledDates.find(function (date) {
                    return date.toDateString() === endDate.toDateString();
                });

                const startDateInPast = startDate < new Date();

                if (containsStartDate || containsEndDate || daysApart < minDays || startDateInPast) {
                    console.log("dates are not available, clearing selection");
                    litepicker.clearSelection();
                    litepicker.show();
                }
            }
        }
    }

    const pet = $(".reservation_pet-group");
    const petNotAllowedError = $("#pets-not-allowed-error");
    const petFeeInfo = $("#pet-fee-info");
    const sendReservationButton = $("#send-reservation");
    $("input[name='reservation[hasPet]']").change(function () {
        let val = $(this).val();

        if (val === "1") {
            if (petNotAllowedError.length) {
                petNotAllowedError.show();
                sendReservationButton.attr("disabled", true);
            } else {
                pet.show();
                pet.find("input").attr("required", "required");
            }

            petFeeInfo.show();
        } else {
            if (petNotAllowedError.length) {
                petNotAllowedError.hide();
                sendReservationButton.attr("disabled", false);
            }

            pet.hide();
            pet.find("input").removeAttr("required");

            petFeeInfo.hide();
        }
    });

    const invoiceData = $(".reservation_invoiceData-group");
    $("input[name='reservation[invoice]']").change(function () {
        let val = $(this).val();

        if (val === "1") {
            invoiceData.show();
            invoiceData.find("input").attr("required", true);
        } else {
            invoiceData.hide();
            invoiceData.find("input").attr("required", false);
        }
    });

    const couponCodeGroup = $(".reservation_couponCode-group");
    const couponCodeInput = $("input[name='reservation[couponCode]']");
    const couponCodeTrigger = $("input[name='reservation[couponCodeTrigger]']");

    function couponCodeTriggered() {
        if (couponCodeTrigger.is(":checked")) {
            couponCodeGroup.show();
            couponCodeGroup.find("input").attr("required", true);
            couponCodeInput.focus();
        } else {
            couponCodeGroup.hide();
            couponCodeGroup.find("input").val("");
            couponCodeGroup.find("input").attr("required", false);
        }
    }

    couponCodeTrigger.change(couponCodeTriggered);
    couponCodeTriggered();

    let codeInputChangeDebounce;
    couponCodeInput.on("keypress keyup keydown", function () {
        sendReservationButton.attr("disabled", true);

        clearTimeout(codeInputChangeDebounce);
        codeInputChangeDebounce = setTimeout(function () {
            let val = couponCodeInput.val();
            if (val.length > 0) {
                $.ajax({
                    url: "/api/coupon/check?code=" + val,
                    method: "GET",
                    success: function (r) {
                        if (r.status === "success") {
                            couponCodeInput.removeClass("is-invalid");
                            couponCodeInput.addClass("is-valid");
                            let message = $("<div class='coupon-message text-success'>" + r.message + "</div>");
                            if (couponCodeInput.next(".coupon-message").length) {
                                couponCodeInput.next(".coupon-message").remove();
                            }
                            couponCodeInput.after(message);
                        } else {
                            couponCodeInput.removeClass("is-valid");
                            couponCodeInput.addClass("is-invalid");
                            let message = $("<div class='coupon-message text-danger'>" + r.message + "</div>");
                            if (couponCodeInput.next(".coupon-message").length) {
                                couponCodeInput.next(".coupon-message").remove();
                            }
                            couponCodeInput.after(message);
                        }
                    },
                    complete: function () {
                        sendReservationButton.attr("disabled", false);
                    }
                });
            } else {
                sendReservationButton.attr("disabled", false);
                couponCodeInput.removeClass("is-invalid");
                couponCodeInput.removeClass("is-valid");
                if (couponCodeInput.next(".coupon-message").length) {
                    couponCodeInput.next(".coupon-message").remove();
                }
            }
        }, 500);
    });

    const childrenAgeData = $(".reservation_childrenAge-group");
    $("input[name='reservation[children]']").on("keypress keyup keydown", function () {
        let val = $(this).val();

        if (val === "0") {
            childrenAgeData.hide();
            childrenAgeData.find("input").attr("required", false);
        } else {
            childrenAgeData.show();
            childrenAgeData.find("input").attr("required", true);
        }
    });

    var placeNameTrigger;
    $("#reservation_placeNumber").on("keypress keyup keydown", {
        target: "#reservation_placeName",
        id: "#reservation_placeNumber"
    }, triggerLoadPlaceName);
    $("#reservation_placeAlternativeNumber").on("keypress keyup keydown", {
        target: "#reservation_placeAlternativeName",
        id: "#reservation_placeAlternativeNumber"
    }, triggerLoadPlaceName);

    function triggerLoadPlaceName(props) {
        clearTimeout(placeNameTrigger);
        placeNameTrigger = setTimeout(loadPlaceName, 200, props);
    }

    function loadPlaceName(props) {
        let target = props.data.target;
        let el = $(props.data.id);
        let value = el.val();

        if (!value) {
            return;
        }

        $.ajax({
            url: "/" + locale + "/api/place/name-by-number/" + value,
            method: "GET",
            beforeSend: function () {

                $(target).val("");
            },
            success: function (r) {
                if (r) {
                    //console.log(r);
                    //console.log(target);
                    $(target).val(r);
                }
            }
        });
    }

    $(".readonly").on('keydown paste focus mousedown', function (e) {
        if (e.keyCode !== 9) // ignore tab
            e.preventDefault();
    });

    $("form[name='reservation']").submit(function () {
        sendReservationButton.attr("disabled", true);

        let width = sendReservationButton.outerWidth();
        let content = sendReservationButton.html();
        sendReservationButton.attr("label", content);
        sendReservationButton.css("width", width + "px");
        sendReservationButton.html('<div class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Nahrávám...</span></div>');

        addEventListener('beforeunload', function () {
            sendReservationButton.attr("disabled", false);
            sendReservationButton.html(sendReservationButton.attr("label"));
        });
    });
});